// extracted by mini-css-extract-plugin
export var footer = "_ov-5";
export var fulfillmentInput = "_ov-0";
export var shipDateInput = "_ov-1";
export var shipmentModal = "_ov-2";
export var shipmentModalContent = "_ov-3";
export var tableContainer = "_ov-4";